module.exports = __webpack_public_path__ + "assets/img/jigong.5893cd32.png";